// extracted by mini-css-extract-plugin
module.exports = {"loadingAnswer":"GenAnswerLoader_loadingAnswer__pKEle","gradientSwoosh":"GenAnswerLoader_gradientSwoosh__WdLai"};